import { Dialog, DialogPanel, DialogTitle } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/outline";
import clsx from "clsx";
import type { ReactNode } from "react";

export { Drawer };

function Drawer({
  open,
  onClose,
  title,
  className,
  children,
}: {
  open: boolean;
  onClose: () => void;
  title: string;
  className?: string;
  children: ReactNode;
}) {
  return (
    <Dialog open={open} onClose={() => {}} className={clsx("relative", className)}>
      <div className="fixed inset-0 bg-black/30 transition-opacity" aria-hidden="true" />
      <div className="fixed inset-y-2 rounded-lg right-2 flex max-w-full pl-10">
        <DialogPanel
          transition
          className="pointer-events-auto w-screen max-w-md transform transition duration-500 ease-in-out data-[closed]:translate-x-full sm:duration-700"
        >
          <div className="rounded-lg flex h-[calc(100vh-16px)] flex-col overflow-hidden bg-white dark:bg-zinc-900 py-6 border border-zinc-200 dark:border-zinc-800">
            <div className="px-4 sm:px-6 flex-shrink-0">
              <div className="flex items-start justify-between">
                <DialogTitle className="text-base font-semibold text-zinc-950 dark:text-white">
                  {title}
                </DialogTitle>
                <div className="ml-3 flex h-7 items-center">
                  <button
                    type="button"
                    onClick={onClose}
                    className="relative rounded-md text-zinc-400 hover:text-zinc-500 dark:text-zinc-500 dark:hover:text-zinc-400"
                  >
                    <span className="absolute -inset-2.5" />
                    <span className="sr-only">Close panel</span>
                    <XMarkIcon aria-hidden="true" className="size-6" />
                  </button>
                </div>
              </div>
            </div>
            <div className="relative mt-6 flex-1 min-h-0 overflow-y-auto">
              {children}
            </div>
          </div>
        </DialogPanel>
      </div>
    </Dialog>
  );
}
